module.exports = __webpack_public_path__ + "img/windows_download_link_fqa.6bab19fa.png";